export const prefix = 'central';
export { TranslationConstants } from '../shared/constants';

export const REPORT_TYPES = {
  localFile: 'local-file',
  masterFile: 'master-file'
};

export const REPORT_TYPE_ROUTES = {
  'local-file': {
    reportInformationPath: '/report-information',
    reportDetailsPath: '/report-details'
  },
  'master-file': {
    reportInformationPath: '/master-file-report-information',
    reportDetailsPath: '/master-file-report-details'
  }
};

export const TEXT_EDITOR_MAX_SIZE = 4194304;